// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LdDfG","col":"styles_col__EzCvK"};